import React from 'react';
import ListItem, { ListItemContent } from '../../../../../elements/ListItem';
import TimeSpan from '../../../../../elements/TimeSpan';
import styles from './ProgramListItem.module.scss';
import PinIcon from '../../../../../../resources/icons/location-pin.svg';

function ProgramListItem(props) {
    const { className = '', classNames = {}, session,  } = props;

    // console.log('DBG session', session);

    return (
        <ListItem key={session.id} tagName="div" className={[className, styles.ProgramListItem].join(' ')}>
            <TimeSpan start={session.start_local} end={session.end_local} startClassName={classNames.startTime} endClassName={classNames.endTime} />
            <ListItemContent>
                <div className={[styles.name, classNames.name].join(' ')}>{session.name}</div>
                {session.location ? (
                    <div className={[styles.location, classNames.location].join(' ')}>
                        <PinIcon /> {session.location}
                    </div>
                ) : null}
            </ListItemContent>
        </ListItem>
    );
}

export default ProgramListItem;
